<template>
	<div class="labels-wrapper" @click.stop>
        <template v-for="label in contact?.labels">
            <div class="label-item" v-if="isAvailableLabel(label)" :style="`color:${label?.color}`"
                 :class="{'rtl' : layoutStore.isRTL}">
                <InlineSvg class="icon" :src="loadFile('label.svg')" />
                <InlineSvg class="close-icon" :src="loadFile('close-bold.svg')" @click="removeLabel(label?.id)"/>
            </div>
        </template>

		<button class="add-btn" @click="showMenu">
			<InlineSvg class="icon" :src="loadFile('plus-icon.svg')" />
		</button>

		<div v-if="visible" class="custom-label-menu" :class="{'rtl' : layoutStore.isRTL}">
			<div class="menu-wrapper">
				<div class="menu-item" v-for="item in labelStore.list">
                    <AppCheckbox :trueValue="item?.id" v-model="checkList" :disabled="isDisabled(item?.id)">
                        <template v-slot:label="{toggle}">
                            <div @click="toggle" class="checkbox-label"
                                 :style="`background-color: ${item?.color_object?.hex_code?.primary};color: ${item?.color_object?.hex_code?.secondary};`">
                                {{item?.name}}
                            </div>
                        </template>
                    </AppCheckbox>
                </div>

                <AppButton
                    startIcon="assets/v2/image/icons/plus.svg"
                    :label="$t('whatsapp.add-new-label')"
                    link
                    variant="brand"
                    size="md"
                    @click="$refs.createEditRef.open()"
                    v-if="labelStore.list?.length < 10"
                    class="tw-my-2"
                />

                <AppButton
                    :label="$t('_save')"
                    size="md"
                    @click="apply()"
                />

			</div>
		</div>

        <CreateEdit ref="createEditRef" @success="labelStore.fetch()"/>
    </div>
</template>

<script setup>
import {computed, onBeforeMount, onBeforeUnmount, onMounted, ref} from 'vue';
import { loadFile } from '@/components/utils.js';
import { useLabelStore } from '@/v2/modules/whatsapp/stores/labels';
import CreateEdit from '@/v2/modules/whatsapp/pages/labels/create-edit/index.vue';
import InlineSvg from '@/v2/components/inline-svg';
import AppSkeleton from '@/v2/components/skeleton.vue';
import { useLayoutStore } from '@/v2/store/shared/layout-store';

const labelStore = useLabelStore();
const layoutStore = useLayoutStore();
const FAILED_TEMPLATE_LABEL_ID = '$FAILED_TEMPLATE$';

const emit = defineEmits(['set-label-menu', 'set-new-labels']);

const props = defineProps({
	contact: {
		type: Object,
		default: () => ({}),
		required: true,
	},
	activeMenu: String,
});

const checkList = ref([]);

const visible = computed(() => {
	return props.activeMenu === props.contact?.id;
});

onMounted(() => {
	document.addEventListener('click', hideMenu);
});

onBeforeUnmount(() => {
	document.removeEventListener('click', hideMenu);
});

const isAvailableLabel = (label) => {
    return isFailedTemplateLabel(label?.id) || labelStore.list.findIndex(el=> el.id === label?.id) > -1;
};

const isFailedTemplateLabel = (id) => {
    return id === FAILED_TEMPLATE_LABEL_ID;
};

const showMenu = (event) => {
    checkList.value = [];
    if(props?.contact?.labels?.length > 0){
        props?.contact?.labels.forEach(item=>{
           if(!isFailedTemplateLabel(item?.id) && isAvailableLabel(item)) checkList.value.push(item?.id);
        })
    }

	emit('set-label-menu', props.contact?.id);
};

const hideMenu = () => {
    emit('set-label-menu', null);
};

const apply = () => {
    console.log("apply");
	if(props.activeMenu === props.contact?.id){
        let newList = [];
        checkList.value.forEach(item =>{
            let elem = labelStore.list?.find(el => el.id === item);
            newList.push({
                color: elem?.color_object?.hex_code?.primary,
                id: elem?.id
            });
        });
        emit('set-new-labels', newList);
    }

	setTimeout(()=>{
        hideMenu();
    },100);
};

const removeLabel = (id) => {
    if (isFailedTemplateLabel(id)) return;

	let newList = [];
	let labels = props?.contact?.labels;

    labels.forEach(item =>{
        if(item.id !== id){
            newList.push({
                color: item?.color,
                id: item?.id
            });
        }
    });
    // console.log("removeLabel - newList",newList);
	emit('set-new-labels', newList);
};

const isDisabled = (id) => {
	return checkList.value.length === 3 && checkList.value.findIndex(el => el === id) === -1;
};



defineExpose({
	showMenu,
});
</script>

<style scoped lang="scss">
.labels-wrapper {
	display: inline-flex;
	gap: 5px;
    .label-item{
        position: relative;
        .close-icon{
            color: #475467;
            position: absolute;
            left: 0;
            right: 0;
            width: 11px;
            margin-inline-start: 5px;
            margin-top: 8px;
            visibility: hidden;
        }

        .icon{
            width: 24px;
        }

        &.rtl{
            .icon{
                transform: rotate(180deg);
            }
            .close-icon{
                margin-top: 6px;
                margin-inline-start: 4px;
            }
        }
        &:hover{
            .close-icon{
                visibility: visible;
            }
        }
    }

	.add-btn {
		background: #eaecf0;
		border: 0;
		border-radius: 100%;
		padding: 0;
		width: 20px;
		height: 20px;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #667085;
		visibility: hidden;

		svg {
			width: 10px;
			height: 10px;
		}
	}

    .custom-label-menu {
        position: absolute;
        background-color: white;
        border: 1px solid #EAECF0;
        box-shadow: 0px 4px 12px 0px #0000003D;
        border-radius: 8px;
        z-index: 1000;
        &.rtl{
            left: 5px;
        }
        .menu-wrapper{
            display: flex;
            gap: 10px;
            padding: 16px;
            flex-direction: column;
            .txt{
                font-size: 14px;
                font-weight: 500;
                color: #0C111D;
                margin-bottom: 0;
            }

            .checkbox-label{
                border-radius: 22px;
                padding: 3px 6px;
                font-size: 12px;
                font-weight: 500;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 95px;
            }

            ::v-deep(button){
              font-size: 14px;
            }
        }
    }
}
</style>
